import React, { useEffect, useState } from "react";
import {
  Box,
  Heading,
  Stat,
  StatLabel,
  StatNumber,
  SimpleGrid,
  Text,
  Flex,
  List,
  ListItem,
  Avatar,
  Progress,
  Divider,
  useColorModeValue,
} from "@chakra-ui/react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import axios from "axios";
import { BASE_URL } from "../../Globalapi/Globalapi";
import BestPerformersCard from "./BestPerfmnce";
import StudentProgressCard from "./StudentProgress";
// import BestPerformersCard from "./BestPerfmnce";

// --- Card Component Base Style ---
const CardContainer = (props) => {
  const bg = useColorModeValue("white", "gray.700");
  //   const shadow = useColorModeValue("lg", "dark-lg");

  return (
    <Box
      bg={bg}
      p={7}
      borderRadius="xs"
      boxShadow="xs"
      borderWidth="1px"
      borderColor={useColorModeValue("gray.100", "gray.600")}
      w="100%"
      transition="transform 0.3s ease"
      _hover={{ transform: "translateY(-3px)", boxShadow: "xl" }}
      {...props}
    />
  );
};

// It can safely call useColorModeValue.
const StatItem = ({ label, value, color }) => {
  const statBg = useColorModeValue(`${color}.50`, `${color}.800`);
  const labelColor = useColorModeValue("gray.600", "gray.300");

  return (
    <Stat p={3} bg={statBg} borderRadius="lg">
      <StatLabel fontWeight="medium" color={labelColor}>
        {label}
      </StatLabel>
      <StatNumber fontSize="xl" color={`${color}.500`}>
        {value}
      </StatNumber>
    </Stat>
  );
};

// --- 1. Attendance Card ---
function AttendanceCard({ attendanceData }) {
  const { present, absent, halfDay, late } = attendanceData;
  const total = present + absent + halfDay + late;

  const COLORS = {
    Present: "#48BB78", // Green (Chakra: green.500)
    Absent: "#F56565", // Red (Chakra: red.500)
    HalfDay: "#ECC94B", // Yellow (Chakra: yellow.500)
    Late: "#ED8936", // Orange (Chakra: orange.500)
  };

  const attendanceDataPie = [
    { name: "Present", value: present, color: COLORS.Present },
    { name: "Absent", value: absent, color: COLORS.Absent },
    { name: "Half Day", value: halfDay, color: COLORS.HalfDay },
    { name: "Late", value: late, color: COLORS.Late },
  ].filter((entry) => entry.value > 0);

  const legendTextColor = useColorModeValue("gray.700", "white"); // Extracted hook

  return (
    <CardContainer>
      <Heading size="md" mb={1} color="teal.600">
        Attendance Summary
      </Heading>
      <Text fontSize="sm" color="gray.500" mb={5}>
        May 14, 2024 - May 21, 2024
      </Text>

      <SimpleGrid columns={4} spacing={3} mb={6}>
        <StatItem label="Present" value={present} color="green" />
        <StatItem label="Absent" value={absent} color="red" />
        <StatItem label="Half Day" value={halfDay} color="yellow" />
        <StatItem label="Late" value={late} color="orange" />
      </SimpleGrid>

      <Divider mb={6} />

      <Flex
        direction={{ base: "column", md: "row" }}
        align="center"
        justify="space-between"
      >
        <Box w={{ base: "100%", md: "50%" }} h="200px">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={attendanceDataPie}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {attendanceDataPie.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </Box>

        <List
          spacing={2}
          w={{ base: "100%", md: "45%" }}
          mt={{ base: 4, md: 0 }}
        >
          {attendanceDataPie.map((entry, index) => (
            <ListItem key={index} display="flex" alignItems="center">
              <Box
                w="10px"
                h="10px"
                borderRadius="full"
                bg={entry.color}
                mr={2}
              />
              <Text fontSize="sm" fontWeight="semibold" color={legendTextColor}>
                {entry.name}: {entry.value} (
                {total > 0 ? ((entry.value / total) * 100).toFixed(1) : 0}%)
              </Text>
            </ListItem>
          ))}
        </List>
      </Flex>
    </CardContainer>
  );
}

// --- 2. Best Performers Card ---
// function BestPerformersCard({ performers }) {
//   return (
//     <CardContainer>
//       <Heading size="md" color="teal.500" mb={5}>
//         Class Performance
//       </Heading>
//       {performers.map((performer, index) => (
//         <Box key={index} mb={5}>
//           <Flex justify="space-between" align="center" mb={1}>
//             <Text fontWeight="bold" fontSize="md">
//               {performer.class}
//             </Text>
//             <Text fontWeight="extrabold" fontSize="lg" color="blue.500">
//               {performer.percentage}%
//             </Text>
//           </Flex>
//           <Progress
//             value={performer.percentage}
//             size="sm"
//             colorScheme="blue"
//             borderRadius="full"
//             hasStripe={performer.percentage < 100}
//             isAnimated
//           />
//         </Box>
//       ))}
//     </CardContainer>
//   );
// }

// function BestPerformersCard({ performers }) {
//   // const itemHoverBg = useColorModeValue("blue.50", "gray.600");
//   // Function to determine color scheme based on percentage
//   const getColorScheme = (percentage) => {
//     if (percentage > 85) return "green";
//     if (percentage > 70) return "blue";
//     return "orange";
//   };

//   // Define hover background outside the map loop to follow Hooks rules
//   const itemHoverBg = useColorModeValue("blue.50", "gray.600");
//   const classNameColor = useColorModeValue("gray.800", "white");

//   return (
//     <CardContainer>
//       {/* Enhanced Header Section */}
//       <Heading size="xl" mb={2} color={useColorModeValue("gray.700", "white")}>
//         Class Performance
//       </Heading>
//       <Text fontSize="sm" color="gray.500" mb={4}>
//         Average performance in assigned classes.
//       </Text>
//       <Divider mb={6} />

//       {/* Performance List */}
//       {performers.map((performer, index) => {
//         const scheme = getColorScheme(performer.percentage);

//         return (
//           <Box
//             key={index}
//             mb={5}
//             p={3}
//             borderRadius="md"
//             transition="all 0.2s"
//             _hover={{ bg: itemHoverBg }} // Added hover effect
//           >
//             <Flex justify="space-between" align="center" mb={1}>
//               {/* Class Name */}
//               <Text
//                 fontWeight="extrabold"
//                 fontSize="lg"
//                 color={useColorModeValue("gray.800", "white")}
//               >
//                 {performer.class}
//               </Text>

//               {/* Percentage */}
//               <Text
//                 fontWeight="extrabold"
//                 fontSize="2xl" // Larger font size for emphasis
//                 color={`${scheme}.500`}
//               >
//                 {performer.percentage}%
//               </Text>
//             </Flex>

//             {/* Progress Bar (Larger and Dynamic Color) */}
//             <Progress
//               value={performer.percentage}
//               size="lg" // Thicker progress bar
//               colorScheme={scheme} // Dynamic color scheme
//               borderRadius="full"
//               hasStripe={performer.percentage < 100}
//               isAnimated
//             />
//           </Box>
//         );
//       })}
//     </CardContainer>
//   );
// }

// --- 3. Student Progress Card ---
// function StudentProgressCard({ studentData }) {
//   const hoverBg = useColorModeValue("gray.50", "gray.800");

//   return (
//     <CardContainer>
//       <Heading size="lg" mb={5}>
//         Top Student Progress
//       </Heading>
//       <List spacing={5}>
//         {studentData.length > 0 ? (
//           studentData.slice(0, 5).map((student) => (
//             <ListItem
//               key={student.id}
//               display="flex"
//               alignItems="center"
//               p={2}
//               borderRadius="lg"
//               _hover={{ bg: hoverBg }} // Used extracted variable here (Fixed Line 386:31)
//             >
//               <Avatar
//                 size="md"
//                 name={student.student_name}
//                 src={student.image_url}
//                 mr={4}
//               />
//               <Flex justify="space-between" w="full" align="center">
//                 <Box>
//                   <Text fontSize="md" fontWeight="bold">
//                     {student.student_name}
//                   </Text>
//                   <Text fontSize="sm" color="gray.500">
//                     Class: {student.class}
//                   </Text>
//                 </Box>
//                 <Text fontSize="xl" fontWeight="extrabold" color="teal.500">
//                   {student.highest_marks}%
//                 </Text>
//               </Flex>
//               <Divider />
//             </ListItem>
//           ))
//         ) : (
//           <Text textAlign="center" color="gray.500">
//             No subject results available.
//           </Text>
//         )}
//       </List>
//     </CardContainer>
//   );
// }

// --- Main Gra Component ---
function Gra() {
  const [subjectResults, setSubjectResults] = useState([]);
  const userid = sessionStorage.getItem("user_id") || "placeholder_id";

  useEffect(() => {
    const fetchSubjectResults = async () => {
      if (!userid || userid === "placeholder_id") return;
      try {
        const response = await axios.post(
          `${BASE_URL}/staff/profile/subject_result.php`,
          {
            pass: userid,
          }
        );

        if (response.data.success) {
          const transformedData = response.data.data.map((item) => ({
            id: item.student_id,
            student_name: item.student_name,
            class: item.class_name,
            image_url: item.student_image_url || "",
            highest_marks: item.highest_marks,
          }));
          setSubjectResults(transformedData);
          // console.log("perfomance:", response);
        } else {
          console.error("Failed to fetch results:", response.data);
        }
      } catch (error) {
        console.error("Error fetching subject results:", error);
      }
    };

    fetchSubjectResults();
  }, [userid]);

  const attendanceData = {
    present: 25,
    absent: 2,
    halfDay: 0,
    late: 1,
  };

  // const bestPerformers = [
  //   { class: "Class IV, C", percentage: 88 },
  //   { class: "Class III, B", percentage: 74 },
  //   { class: "Class V, A", percentage: 92 },
  // ];

  return (
    <Box p={0}>
      <SimpleGrid columns={{ base: 1, md: 1 }} spacing={6}>
        <AttendanceCard attendanceData={attendanceData} />
        <BestPerformersCard />
        <StudentProgressCard  studentData={subjectResults} />
      </SimpleGrid>
    </Box>
  );
}

export default Gra;
